import { ContainerModule } from '@evertel/di'

import {
    DocumentMediaWriteWidgetController,
    SchemaMediaController,
    SchemaBuilderController
} from './controller'

import {
    SchemaMediaUtils
} from './utils'

const DI_WEB_DOCUMENT_MODULE = new ContainerModule((m) => {
    // Controller
    m.bind(DocumentMediaWriteWidgetController).toSelf()
    m.bind(SchemaMediaController).toSelf()
    m.bind(SchemaMediaUtils).toSelf()
    m.bind(SchemaBuilderController).toSelf()
})

export {
    DI_WEB_DOCUMENT_MODULE
}
